import { Component, HostListener, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RNAVModel } from 'src/app/models/configuration';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProjectService } from 'src/app/services/project.service';

@Component({
  selector: 'app-rnav',
  templateUrl: './rnav.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class RnavComponent implements OnInit {

  configurationController : ConfigurationService;
  form : FormGroup;
  constructor(configurationController : ConfigurationService,
    private projectService : ProjectService,
    public bsModalRef : BsModalRef) {
      this.configurationController = configurationController;
    }

  ngOnInit(): void {
    this.configurationController.saveChangesState();
    this.form = new FormGroup({
      minDMEFacilityRange : new FormControl(this.configurationController.currentConfiguration.rnav.minDME,[Validators.min(3),Validators.max(160)]),
      maxDMEFacilityRange : new FormControl(this.configurationController.currentConfiguration.rnav.maxDME,[Validators.min(3),Validators.max(160)]),
      maxElevationAngle : new FormControl(this.configurationController.currentConfiguration.rnav.maxElevationAngle,[Validators.min(0),Validators.max(90)]),
      conventionalMaxRange : new FormControl(this.configurationController.currentConfiguration.rnav.conventionalMaxRange,[Validators.min(3),Validators.max(160)]),
      dopplerMaxRange : new FormControl(this.configurationController.currentConfiguration.rnav.dopplerMaxRange,[Validators.min(3),Validators.max(160)]),
      signalInSpaceErrorBudget : new FormControl(this.configurationController.currentConfiguration.rnav.signalInSpaceErrorBudget,[Validators.min(0),Validators.max(5)]),
      subtendedAngleRange : new FormControl(),
      redundancy : new FormControl(),
      nse : new FormControl(),
      subtendedAngle : new FormControl(),
      availablePairs : new FormControl(),

    },{validators : this.minMaxDMEValidator })
  }
   minMaxDMEValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const min = control.get('minDMEFacilityRange');
    const max = control.get('maxDMEFacilityRange');

    return min && max && min.value >= max.value ? { minMaxError: true } : null;
  };
  @HostListener('document:keydown.escape', ['$event']) 
  onEscape(event: KeyboardEvent) {
    this.cancelConfiguration(false); // escape key already hides the modal
  }

  cancelConfiguration(hideModal: boolean = true):void {
    this.configurationController.cancelConfigurationPopup();
    hideModal? this.bsModalRef.hide(): false;
  }

  saveConfiguration(): void {
    if(!this.projectService.projectEditable()){
      this.cancelConfiguration();
      return;
    } 
    this.configurationController.saveConfigurationPopup(this.form, true);
    this.bsModalRef.hide();
  }

  retoreDefaults(){
    let rnavConfiguration: RNAVModel = new RNAVModel();

    rnavConfiguration.minDME = 3;
    rnavConfiguration.maxDME = 160;
    rnavConfiguration.maxElevationAngle = 40;
    rnavConfiguration.subtendedAngleRange = "30-150";
    rnavConfiguration.conventionalMaxRange = 60;
    rnavConfiguration.dopplerMaxRange = 75;
    rnavConfiguration.signalInSpaceErrorBudget = 0.05;
    rnavConfiguration.redundancy = true;
    rnavConfiguration.subtendedAngle = true;
    rnavConfiguration.nse = true;
    rnavConfiguration.availablePairs = false;


    this.configurationController.currentConfiguration.rnav = rnavConfiguration;
  }

}
